import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import { Dialog } from 'frame/components'
import { constants } from '../../module'
import Form from './form'

const Item = ({
  id,
  data,
  fleetIds,
  fetchStatus,
  saveStatus,
  userRoles,
  errorMessage,
  onFetch,
  onUpdate,
  onDelete,
}) => {

  const navigate = useNavigate()

  const onClose = () => navigate(constants.PATH_ALL)

  const onSave = (payload) =>
    onUpdate(payload)

  // Same as componentDidMount
  // We either use material ui 'useStyles' or we wrap the component
  // in an HoC and pass the styles down or completely
  // redo the way styles are done if we want to change this.
  useEffect(() => {
    onFetch(id, fleetIds)
  }, [id, fleetIds]) // eslint-disable-line

  const title = data?.booking?.requestType === 'Relief'
    ? `Relief Vehicle Booking - ${data?.booking?.registration ?? data?.contract?.registration}`
    : `Rental Vehicle Booking`

  const isLoading = !data
  const isSaving = saveStatus === 'processing'
  const hasErrored = fetchStatus === 'error'
  const savingError = saveStatus === 'error'

  const loadingErrorMessage = hasErrored
    ? 'Whoops, we could not find that booking right now.'
    : null

  return (
    <Dialog
      open
      minHeight={700}
      size="md"
      aria-labelledby="Request Relief/Rental Vehicle"
      title={title}
      errorMessage={loadingErrorMessage}
      loading={isLoading || isSaving}
      onClose={onClose}>
      {(data && ! hasErrored) && (
        <Grid
          container>
          <Grid item xs={12}>
            <Form
              data={data}
              disabled={isLoading}
              error={savingError}
              userRoles={userRoles}
              errorMessage={errorMessage}
              onClose={onClose}
              onSave={onSave}
              onDelete={onDelete}/>
          </Grid>
        </Grid>
      )}
    </Dialog>
  )
}

Item.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  data: PropTypes.object,
  fleetIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  fetchStatus: PropTypes.string,
  saveStatus: PropTypes.string,
  userRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  errorMessage: PropTypes.string,
  onFetch: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default Item
